<template>
    <!-- <nav> -->
    <nav v-if="user">
        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" :timeout="4000" top color="primary">
            <span class="info--text">Awesome! You added a new project</span>
            <v-btn depressed small color="grey lighten-1" @click="snackbar=false">Close</v-btn>
        </v-snackbar>
        <v-snackbar v-model="alertsnackbar" :timeout="4000" color="red">
            <span class="white--text">Please login first!</span>
            <v-btn text small color="grey lighten-3" @click="alertsnackbar=false">Close</v-btn>
        </v-snackbar>
        <v-app-bar flat app color="grey lighten-3">
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="info--text d-none d-sm-flex">
                <a class="font-weight-light info--text" @click="backhome">YourConcierge</a>
                <span class="grey-darken-4--text">TPO</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- dropdown menu -->
            <!-- <v-row class="mr-6" justify="end">
                <v-menu offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn small depressed light v-on="on">
                            <v-icon left>expand_more</v-icon>
                            <span class="info--text">MENU</span>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="item in items" :key="item.title" link :to="item.route">
                            <v-list-item-title>
                                {{item.title}}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-row> -->
            <!-- user login buttons -->
            <v-btn v-if="!user" small text color="info" :to="{name:'login'}">
                <span>Login</span>
                <v-icon right>mdi-account-key-outline</v-icon>
            </v-btn>
            <v-btn v-if="!user" text small color="info" :to="{name:'signup'}">
                <span>Signup</span>
                <v-icon right>mdi-new-box</v-icon>
            </v-btn>
            <v-btn v-if="user" text small color="info" @click="profile">
                <v-icon>mdi-account-badge</v-icon>
                <span>{{user.email}}</span>
            </v-btn>
            <v-btn v-if="user" text small color="info" @click="logout">
                <span>Sign Out</span>
                <v-icon right>mdi-account-arrow-right-outline</v-icon>
            </v-btn>
        </v-app-bar>
        <!-- Navigation Drawer -->
        <v-navigation-drawer v-model="drawer" app temporary left class="white">
            <!-- <v-layout column align-center>
                <v-flex class="mt-5">
                    <v-avatar size="100">
                        <img src="/avatar-1.jpg" alt="">
                    </v-avatar>
                    <p class="grey--text subheading mt-2 pl-7">Jesse</p>
                </v-flex>
                <v-flex class="my-1">
                    <Popup @projectAdded="snackbar=true"/>
                </v-flex>
            </v-layout> -->
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="title info--text">
                        TPO Knowldege
                    </v-list-item-title>
                    <v-list-item-subtitle class="font-weight-light">
                        Your Concierge
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list dense nav>
                <v-list-item
                v-for="item in items"
                :key="item.title"
                link 
                :to="item.route"
                >
                    <v-list-item-icon>
                        <v-icon class="nfo--text">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title class="font-weight-light info--text">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
/* eslint-disable no-console */
// import Popup from './Popup.vue'
import {auth, db} from '@/fb'
export default {
    // components: {Popup},
    data(){
        return {
            drawer: false,
            alert:null,
            user:null,
            items: [
                    { title: 'Tickets in Freshdesk', icon: 'dashboard', route: '/'},
                    { title: 'Report History', icon: 'folder' , route: '/report-history'},
                    { title: 'Researchers', icon: 'person' , route: '/researchers'},
                    { title: 'Ticket Assignment', icon: 'mdi-account-switch' , route: '/assign-ticket'},
                    { title: 'License Applications', icon: 'drive_eta' , route: '/license-applications'},
                    // { title: 'Report', icon: 'mdi-view-dashboard', route: '/report'},
                    // { title: 'New Report', icon: 'mdi-pencil' , route: '/createreport'},
                    { title: 'About', icon: 'mdi-tooltip-outline' , route: '/about'},
                    ],
            snackbar:false,
            alertsnackbar:false,
        }
    },
    methods :{
        backhome(){
            if(this.$router.currentRoute.name !== 'dashboard' && this.$router.currentRoute.name !== 'signup'){
                this.$router.push({name:'dashboard'})
                .catch(()=>{
                    this.alertsnackbar = true
                })
            }
        },
        logout(){
            auth.signOut().then(()=>{
                this.$router.push({name:'login'})
            }).
            catch(err=>{
                console.log(err)
            })
        },
        profile(){
            this.$router.push({name:'UserProfile', params:{id:auth.currentUser.uid}})
        }
    },
    created(){
        let userEmailList = []
        let ref = db.collection('users')
        ref.get().then(snap=>{
            snap.forEach(doc=>{
                userEmailList.push(doc.data().email)
            })
            
            auth.onAuthStateChanged((user)=>{
                if(user){
                    if(user.emailVerified){
                        if(userEmailList.includes(user.email)){
                            this.user = user
                        }else{
                            this.user = null 
                        }
                    }else{
                       this.user = null 
                    }
                }else{
                    this.user = null
                }
            })
        })
    }
}
</script>